import React from 'react'

import { buildings } from '../../../core/controllers/Buildings'
import { roomRenderer } from '../../../core/graphic_engine/controllers/RoomRenderer';
import { sensorRenderer } from '../../../core/graphic_engine/controllers/SensorRenderer';
import { modal } from '../../../core/utilities/modal';

export default class EditorBar extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // #  We need to setup our slimScroll on our editing window
		jQuery(jQuery('.editor-bar .scroll-attach')).slimScroll({
        	height: '450px',
            width: '130px',
			alwaysVisible: true
        });

        jQuery(jQuery('.editor-bar').find(".tooltip_custom_editor")).hover(function() {
                jQuery(this).find('[data-toggle="tooltip"]').tooltip('show');
            }, function() {
                jQuery(this).find('[data-toggle="tooltip"]').tooltip('hide');
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    /* Handle editor bar clicks */
    changeRoom(e) {
        // TODO move this to component
        var id = jQuery(jQuery(e.target)[0].parentElement).attr('id');
        // updare active element
        jQuery(".changeRoomType.active").removeClass('active');
        jQuery(jQuery(e.target)[0].parentElement).toggleClass('active');
        // trigger update in RoomRenderer
        roomRenderer.updateRoomType(id);
    }

    changeSensor(e) {
        // TODO move this to component
        var id = jQuery(jQuery(e.target)[0].parentElement).attr('id');
        // updare active element
        jQuery(".changeRoomType.active").removeClass('active');
        jQuery(jQuery(e.target)[0].parentElement).toggleClass('active');
        // trigger update in RoomRenderer
        sensorRenderer.updateSensorType(id);
    }
    /* end */

    /**
     * Saves building floor plan
     * @param {*} e 
     */
    saveFloorPlan(e) {
        var self = this;
        var formFields = '<br/><form>' + 
        '<div class="row"><div class="col-md-12"><div class="form-group">' +
        '<label>Floor Plan Title</label>' +
        '<input type="text" class="form-control floor-plan-title" name="title" placeholder="Lease Title" id="title"/>' +
        '</div></div></div></form>';
        modal.showPopOverWithDataEntry("Save Floor Plan", "Saving floor plans allow for easier building creation.  This will save your current floor layout, exluding all associated data.", formFields, "Save Floor Plan", function(e) {
            var title = jQuery('.floor-plan-title').val();
            if(title.length > 0) {
                buildings.saveBuildingLevelFloorPlan(title, self.props.buildingID, self.props.levelID);      
            } else {
                jQuery(".modal-backdrop").fadeOut().remove();
                modal.showInfo("Missing Information! Please enter a floor plan title.", "warning", "top", "center");
            }
        });
    }
    /**
     * Loads a floor plans
     * @param {*} e 
     */
    loadFloorPlans(e) {
        var self = this;

        buildings.loadBuildingLevelFloorPlan(self.props.buildingID, function(data) {
            var templates = data.data.level_templates;

            if(templates === undefined) {
                modal.showInfo("No templates found, try adding some!", "warning", "top", "center");
                return;
            }
            var formFields = '<br/><form>' +
            '<div class="row"><div class="col-md-12"><div class="form-group">' +
            '<label>Select a Floor Plan</label>' +
            '</br><select class="building-template-floor-plan-id">' +
            '<option value="0">Select a Floor Plan</option>';
            for(var i = 0; i < templates.size(); i++) {
                formFields += '<option value="'+templates[i].building_levels_template_id+'">'+templates[i].title+'</option>';
            }
            formFields += '</select></div></div></div></form>';
            modal.showPopOverWithDataEntry("Load Floor Plan", "<b><i>Warning</i></b> Loading a floor plan will erase ALL data on this floor.", formFields, "Load", function(e) {
                var building_floor_plan_id = jQuery('.building-template-floor-plan-id').val();
                if(building_floor_plan_id != "0") {
                    buildings.implementBuildingFloorPlan(building_floor_plan_id, self.props.buildingID, self.props.levelID);      
                } else {
                    jQuery(".modal-backdrop").fadeOut().remove();
                    modal.showInfo("Missing Information! Select a floor plan template.", "warning", "top", "center");
                }
            });
        });
    }

    render(){
        return (
            <div class={"editor-bar row " + this.props.editMode}>
                <div class="col-sm-3 col-md-2 editor-sidebar scroll-attach">
                  <ul class="editor-nav editor-nav-sidebar">
                    <li>
                    	<span class="tooltip_custom_editor" data-toggle="collapse" data-target="#rooms" role="button"><i data-toggle="tooltip" data-original-title="Select Space Type" class="fa fa-cube"></i></span>
                    	<ul class="collapse inner-list" id="rooms" >
                        	{/* <li>
                                <span data-toggle="collapse" data-target="#one" class="inner-header"><i class="fa fa-cube"></i></span>
                                <ul class="collapse inner-list xbyx" id="one" >
                                    <li>
                                        <span class="changeRoomType active tooltip_custom_editor" id="onebysingleRoom" onClick={this.changeRoom.bind(this)}>
                                            <span data-toggle="tooltip" data-original-title="One by One Space"></span>
                                            <i class="fa fa-stop"></i>
                                            <span class="white"> x </span>
                                            <i class="fa fa-stop"></i>
                                        </span>
                                    </li>
                                    <li><span class="changeRoomType tooltip_custom_editor" id="onebytwoRoom" onClick={this.changeRoom.bind(this)}>
                                        <span data-toggle="tooltip" data-original-title="One by Two Space"></span>
                                        <i class="fa fa-stop"></i><span class="white"> x </span><i class="fa fa-stop"></i><i class="fa fa-stop"></i></span></li>
                                    <li><span class="changeRoomType tooltip_custom_editor" id="onebytripleRoom" onClick={this.changeRoom.bind(this)}>
                                        <span data-toggle="tooltip" data-original-title="One by Three Space"></span>
                                        <i class="fa fa-stop"></i><span class="white"> x </span><i class="fa fa-stop"></i><i class="fa fa-stop"></i><i class="fa fa-stop"></i></span></li>
                                </ul>
                            </li> */}
                            <li>
                                <span data-toggle="collapse" data-target="#two" class="inner-header"><i class="fa fa-cube"></i></span>
                                <ul class="collapse inner-list xbyx" id="two" >
                                    <li><span class="changeRoomType tooltip_custom_editor" id="twobytwoRoom" onClick={this.changeRoom.bind(this)}>
                                        <span data-toggle="tooltip" data-original-title="Two by Two Space"></span>
                                        <i class="fa fa-stop"></i><i class="fa fa-stop"></i><span class="white"> x </span><i class="fa fa-stop"></i><i class="fa fa-stop"></i></span></li>
                                    <li><span class="changeRoomType tooltip_custom_editor" id="twobythreeRoom" onClick={this.changeRoom.bind(this)}>
                                        <span data-toggle="tooltip" data-original-title="Two by Three Space"></span>
                                        <i class="fa fa-stop"></i><i class="fa fa-stop"></i><span class="white"> x </span><i class="fa fa-stop"></i><i class="fa fa-stop"></i><i class="fa fa-stop"></i></span></li>
                                    <li><span class="changeRoomType smaller tooltip_custom_editor" id="twobyfourRoom" onClick={this.changeRoom.bind(this)}>
                                        <span data-toggle="tooltip" data-original-title="Two by Four Space"></span>
                                        <i class="fa fa-stop"></i><i class="fa fa-stop"></i><span class="white"> x </span><i class="fa fa-stop"></i><i class="fa fa-stop"></i><i class="fa fa-stop"></i><i class="fa fa-stop"></i></span></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>
                    	<span class="tooltip_custom_editor" data-toggle="collapse" data-target="#sensors" role="button"><i data-toggle="tooltip" data-original-title="Add a sensor" class="icon-icons8-sensor"></i></span>
                    	<ul class="collapse inner-list" id="sensors" >
                            <li>
                                <span class="changeRoomType tooltip_custom_editor" id="watersensor" onClick={this.changeSensor.bind(this)}>
                                    <span data-toggle="tooltip" data-original-title="Water Sensor"></span>
                                    <i class="icon-icons8-water"></i>
                                </span>
                            </li>
                            <li>
                                <span class="changeRoomType tooltip_custom_editor" id="doorsensor" onClick={this.changeSensor.bind(this)}>
                                    <span data-toggle="tooltip" data-original-title="Door Sensor"></span>
                                    <i class="icon-icons8-door-sensor-alarmed"></i>
                                </span>
                            </li>
                            <li>
                                <span class="changeRoomType tooltip_custom_editor" id="firealarm" onClick={this.changeSensor.bind(this)}>
                                    <span data-toggle="tooltip" data-original-title="Fire Alarm"></span>
                                    <i class="icon-icons8-fire-alarm-box"></i>
                                </span>
                            </li>
                            <li>
                                <span class="changeRoomType tooltip_custom_editor" id="tempsensor" onClick={this.changeSensor.bind(this)}>
                                    <span data-toggle="tooltip" data-original-title="Tempeture Sensor"></span>
                                    <i class="icon-icons8-thermometer-automation"></i>
                                </span>
                            </li>
                        </ul>
                    </li>
                  	<li>
                    	<span class="tooltip_custom_editor" data-toggle="collapse" data-target="#features"><i class="fa fa-bolt" data-toggle="tooltip" data-original-title="Load Floor Plan" onClick={this.loadFloorPlans.bind(this)}></i></span>
                    </li>
                    <li><span class="tooltip_custom_editor"><i class="fa fa-floppy-o" data-toggle="tooltip" data-original-title="Save Floor Plan" onClick={this.saveFloorPlan.bind(this)}></i></span></li>
                    <li class="control-group"></li>
                  </ul>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Graphics/Editor/EditorBar.jsx